const IS_LIVE_STREAM_SUPPORTED = 'serviceWorker' in navigator;

export default IS_LIVE_STREAM_SUPPORTED;
